import { get } from 'app/utils/axios/kheti'

const getVillagesByBlock = async (id: string) => {
  try {
    const res =  await get<{ id: string; name: string }[]>(
      `common/v1/block/${id}/villages`
    );
    return Object.entries(res)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as { id: string; name: string }[];
  } catch (e) {
    return [];
  }
};

export default getVillagesByBlock;
